import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { reloadOnStaleChunk } from './router/staleChunkReload.js'
import '@/assets/main.css'

// 배포 뒤 열어 둔 탭에서 옛 판 화면 파일이 404 면 가려던 주소를 새로 연다.
reloadOnStaleChunk(router)

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.mount('#app')
